const header = {
  'innovations': 'Innovations',
  'features': 'Features',
  'offers': 'Offers',
  'contact': 'Contact',
  'login': 'Log in',
}

export default header
